import { RedRoundCheck } from '../../assets/imageAssets';
import { usePaymentMutation, useResumePaymentMutation } from '../../api/mutations/payment.query';
import { useState } from 'react';

const PaymentCard = ({
    popular = false,
    planText,
    price,
    infoText,
    nextBillingDate,
    benefitsList,
    paymentId,
    onBeforePayment,
    navigate,
    buttonText = 'Choose Plan',
    isActive = false,
    disabled = false,
    upgradeLabel,
    onCancelSubscription,
    onResumeSubscription,
    subscriptionStatus,
    isCanceled = false,
    isPauseScheduled = false,
}) => {
    const { mutate } = usePaymentMutation();
    const [isProcessing, setIsProcessing] = useState(false);
    
    const handlePayment = async (paymentId) => {
        if (isProcessing) return;
        
        setIsProcessing(true);
        
        // Add paying=true query parameter
        if (navigate) {
            navigate('/payment?paying=true', { replace: true });
        }
        
        if (onBeforePayment) {
            const canProceed = await onBeforePayment(paymentId);
            if (!canProceed) {
                setIsProcessing(false);
                return;
            }
        }
        
        mutate({premium_plan: paymentId}, {
            onSettled: () => {
                setIsProcessing(false);
            }
        });
    }

    const handleClick = () => {
        if (buttonText === 'Resume Subscription' && onResumeSubscription) {
            onResumeSubscription();
            return;
        }
        if (buttonText === 'Cancel Subscription' && onCancelSubscription) {
            onCancelSubscription();
            return;
        }
        handlePayment(paymentId);
    };

    const getStatusTag = () => {
        if (!isActive) return null;
        if (isCanceled) {
            return <span className="active-tag canceled-tag">Canceled</span>;
        }
        if (subscriptionStatus === 'paused') {
            return <span className="active-tag paused-tag">Paused for 30 days</span>;
        }
        return <span className="active-tag">Active</span>;
    };

    return (
        <div className={`payment-card-wrapper ${upgradeLabel ? 'has-upgrade-label' : ''}`}>
            {upgradeLabel && (
                <div className="payment-card__upgrade-label">{upgradeLabel}</div>
            )}
            <div className={`payment-card ${popular ? 'popular' : ''} ${isActive ? 'active' : ''}`}>
            <div className="payment-card__content">
                <h5 className='flex flex-align-center flex-between'>
                    {planText}
                    {isActive && getStatusTag()}
                    {!isActive && popular &&
                        <span className="most-popular">Most Popular</span>
                    }
                </h5>
                <div className="price">
                    <p>{price}</p>
                    <sub>/mth</sub>
                </div>
                <div className="info-text">
                    {infoText}
                    {nextBillingDate && (
                        <div className={isPauseScheduled ? 'pause-scheduled' : ''}>
                            {isCanceled 
                                ? 'Expires on' 
                                : subscriptionStatus === 'paused' 
                                    ? 'Resume on' 
                                    : isPauseScheduled
                                        ? `Your subscription expires on ${nextBillingDate}, after which the pause begins.`
                                        : `Next billing date: ${nextBillingDate}`}
                        </div>
                    )}
                </div>
                {benefitsList?.map((item) => {
                    return (
                        <div className="benefit-item flex flex-align-center">
                            <img src={RedRoundCheck} alt="" />
                            {item.text}
                        </div>
                    );
                })}
            </div>
            <div className="payment-card__bottom">
                <button 
                    onClick={handleClick} 
                    disabled={disabled || isProcessing}
                >
                    {isProcessing ? 'Processing...' : buttonText}
                </button>
            </div>
        </div>
        </div>
    );
}

export default PaymentCard;